<template>
  <div>
    <van-nav-bar title="邀请好友" left-arrow @click-left="$router.back()" />
    <div class="card">
      <div class="label">我的邀请码</div>
      <div class="code">{{ profile.inviteCode || '—' }}</div>
      <div class="label">邀请链接</div>
      <div class="link">{{ inviteUrl }}</div>
      <van-button block type="info" class="gap" @click="copyLink">复制链接</van-button>
      <van-button block plain type="info" @click="share">系统分享</van-button>
    </div>
  </div>
</template>

<script>
import { getProfile, getShareConfig } from '../api'

export default {
  data() {
    return { profile: {}, shareConfig: { title: '会员中心', desc: '邀请你加入' } }
  },
  computed: {
    inviteUrl() {
      if (!this.profile.inviteCode) return ''
      const path = location.pathname || '/'
      return location.origin + path + '#/register?code=' + this.profile.inviteCode
    }
  },
  created() {
    getProfile().then(res => { this.profile = res.data || {} })
    getShareConfig().then(res => { this.shareConfig = res.data || this.shareConfig })
  },
  methods: {
    copyLink() {
      const text = this.inviteUrl
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this.$toast('链接已复制')).catch(() => this.copyFallback(text))
        return
      }
      this.copyFallback(text)
    },
    copyFallback(text) {
      const input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$toast('链接已复制')
    },
    share() {
      const payload = { title: this.shareConfig.title, text: this.shareConfig.desc, url: this.inviteUrl }
      if (navigator.share) {
        navigator.share(payload).catch(() => {})
        return
      }
      this.copyLink()
    }
  }
}
</script>

<style scoped>
.card { margin: 16px; background: #fff; border-radius: 12px; padding: 16px; }
.label { color: #888; font-size: 13px; }
.code { font-size: 28px; font-weight: 700; letter-spacing: 2px; margin: 8px 0 16px; }
.link { word-break: break-all; margin: 8px 0 16px; }
.gap { margin-bottom: 10px; }
</style>
